import axios from 'axios'

const addressApiClient = axios.create({
  baseURL: import.meta.env.VITE_BACKEND_ADDRESSAPI_URL,
})

export default addressApiClient
